"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
class TypeaheadInput extends react_1.default.Component {
    showOptions = false;
    filter = undefined;
    inputElement = null;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            showOptions: mobx_1.observable,
            filter: mobx_1.observable,
            selectedOption: mobx_1.computed,
            options: mobx_1.computed,
            onShowOptions: mobx_1.action.bound,
        });
    }
    componentDidMount() {
        document.addEventListener('click', this.onShowOptions);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onShowOptions);
    }
    get selectedOption() {
        if (this.filter !== undefined) {
            return this.filter;
        }
        const selected = this.props.options.find((option) => option.value === this.props.value);
        return selected ? selected.label : '';
    }
    get options() {
        if (this.filter !== undefined) {
            return this.props.options.filter((option) => option.label.toLowerCase().indexOf(this.filter?.toLowerCase() ?? '') !== -1);
        }
        return this.props.options;
    }
    render() {
        const { value, placeholder, onChange } = this.props;
        return (react_1.default.createElement("div", { className: "znd-typeahead-input" },
            react_1.default.createElement("input", { type: "text", className: "form-control", value: this.selectedOption, ref: (element) => {
                    this.inputElement = element;
                }, onFocus: (0, mobx_1.action)(() => {
                    this.showOptions = true;
                }), onChange: (0, mobx_1.action)((event) => {
                    this.showOptions = true;
                    this.filter = event.target.value;
                }), placeholder: placeholder }),
            react_1.default.createElement("ul", { className: (0, classnames_1.default)('znd-typeahead-input__options', {
                    'znd-typeahead-input__options--visible': this.showOptions,
                }) }, this.options
                .filter((option) => (option.value ?? null) !== null)
                .map((option) => (react_1.default.createElement("li", { className: (0, classnames_1.default)('znd-typeahead-input__options-item', {
                    'znd-typeahead-input__options-item--selected': option.value === value,
                }), key: option.value, onClick: (0, mobx_1.action)(() => {
                    this.filter = undefined;
                    this.showOptions = false;
                    onChange(option.value);
                }) }, option.label)))),
            react_1.default.createElement("div", { className: "znd-typeahead-input__icon" },
                react_1.default.createElement("i", { className: "icon-angle-down" }))));
    }
    onShowOptions(event) {
        if (!(event.target instanceof HTMLElement)) {
            return;
        }
        if (this.inputElement && this.inputElement.contains(event.target)) {
            return;
        }
        this.showOptions = false;
    }
}
exports.default = (0, mobx_react_1.observer)(TypeaheadInput);
